import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'cosmos-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss'],
})
export class SearchbarComponent implements OnInit, OnDestroy {
  @Input() public placeholderContent: string;

  public _filterSearchTerm: FormGroup;
  private readonly _searchValueSubject = new Subject<string>();
  public appliedSearchTerm$ = this._searchValueSubject.asObservable();

  public constructor(
    private readonly _formBuilder: FormBuilder,
  ) {}

  public ngOnInit(): void {
    this._filterSearchTerm = this._formBuilder.group({
      filter: '',
    });
  }

  public ngOnDestroy(): void {
    this._searchValueSubject.complete();
  }

  public submitSearch() {
    this._searchValueSubject.next(this._filterSearchTerm.get('filter')?.value);
  }
}
